import { db, auth } from "../../firebase";
import { collection, onSnapshot, query, orderBy } from "firebase/firestore";

/**
 * 🔹 Listen to notifications for the currently logged-in vendor in real-time
 * @param {function} setNotifications - function to update notifications in state
 * @returns {function} unsubscribe - cleanup function for listener
 */
export const listenToNotifications = (setNotifications) => {
  const user = auth.currentUser;
  if (!user) {
    console.error("❌ No authenticated user found.");
    return;
  }

  try {
    const notificationsRef = collection(
      db,
      "vendorUsers",
      user.uid,
      "notifications"
    );

    const q = query(notificationsRef, orderBy("createdAt", "desc"));

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const data = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setNotifications(data);
      },
      (error) => {
        console.error("⚠️ Error fetching notifications:", error);
        setNotifications([]);
      }
    );

    return unsubscribe;
  } catch (error) {
    console.error("🔥 listenToNotifications failed:", error);
    setNotifications([]);
  }
};
